<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import {couponConf} from "@/utils/config";
import router from "@/router";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import {copyText} from "@/utils/func";

const type = computed(() => couponConf.sqwl)
const headerImg = require("@/assets/images/sqwl/coupon-title.png");
const order = ref({})
const orderFlag = ref(false)
const route = useRoute()
const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  }
});
const emit = defineEmits(["login"]);
const rechargeStep = ref("waiting_recharge");
const welRecharge = [
  require("@/assets/images/sqwl/cdwl.jpg"),
  require("@/assets/images/sqwl/cqwl.jpg")
];
const realFlag = ref(false)
const showRech = ref("")
onMounted(() => {
  if (route.query?.order) {
    new axiosApi({
      encode: "site",
      method: "coupon/orderDetails",
      body: {
        ordersn: route.query.order
      }
    }).send(res => {
      if (res.message.code === "000") {
        order.value = res.data
        orderFlag.value = true
      }
    })
  }
})
</script>

<template>
  <div class="coupon-list">
    <div class="product-header">
      <div class="bottom-header">
        <el-image :src="headerImg"/>
      </div>
    </div>
    <div class="coupon-lst" v-if="props.couponLst.length">
      <div class="coupon-items" v-for="coupon in props.couponLst[0].data" :key="coupon.id">
        <div class="coupon-prices">
          <span class="face_value"><sup class="unit" style="font-size: .8rem">￥</sup>{{ parseFloat(coupon.face_value) }}</span>
        </div>
        <div class="coupon-contents">
          <h4 style="font-size: .8rem">{{ coupon.name }}（{{ coupon.title }}）</h4>
          <div class="coupon-values">
            <div class="coupon-discount">
              <b class="coupon-discount-values">{{
                  coupon.score_data?.scal.discount
                }}</b>{{ coupon.score_data?.scal.unit }}
            </div>
            <div class="btn">
              <el-button size="small" type="danger" color="#E12020" round
                         v-if="Object.keys(props.account).length < 1 || parseFloat(props.account.balance_miles) >= coupon?.score_data?.scal?.discount "
                         @click="router.push({name:'detail',params:{id:coupon.id},query:{contents: 'recharge'}})">
                立即兑换
              </el-button>
              <el-button type="info" round v-else disabled size="small">里程不足</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="recharge-step-items">
    <div class="recharge-step-items-tabs" :class="rechargeStep">
      <div class="step-item-1" @click="rechargeStep='waiting_recharge'"></div>
      <div class="step-item-1" @click="rechargeStep='real_recharge'"></div>
    </div>
    <div class="recharge-step-items-content">
      <div class="recharge-content" v-if="rechargeStep === 'waiting_recharge'">
        <div class="recharge-content-its" v-for="(cont,inx) in type.desc" :key="inx">
          <h3 v-if="cont.title.length">{{ cont.title }}</h3>
          <ol class="recharge-content-val">
            <li v-for="(conte,inx) in cont.content" :key="inx" v-html="conte"></li>
          </ol>
        </div>
      </div>
      <div class="real-content" v-if="rechargeStep === 'real_recharge'">
        <div class="real-content-box" v-for="products in  props.couponLst[0].data" :key="products.id">
          <div class="real-content-left">
            <h4>{{ products.name }}</h4>
            <h4>{{ products.title }}<i class="ticket-font ticket-login-full"></i></h4>
          </div>
          <div class="real-content-right">
            <el-button type="danger" color="#E12020" round
                       @click="router.push({name: 'detail',params:{id:products.id},query:{contents: 'ticket'}})">
              点击查看景区列表
            </el-button>
          </div>
        </div>
        <!--        <div class="real-content-box">-->
        <!--          <div class="real-content-left">-->
        <!--            <h4>大重庆旅游年卡</h4>-->
        <!--            <h4>使用激活指南<i class="ticket-font ticket-login-full"></i></h4>-->
        <!--          </div>-->
        <!--          <div class="real-content-right">-->
        <!--            <el-button type="danger" color="#E12020" round @click="showRech=1,realFlag=true">详情请点击查看</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
  <el-dialog v-model="realFlag" width="97%" top="15px">
    <el-image :src="welRecharge[showRech]"/>
  </el-dialog>
  <el-dialog v-model="orderFlag" width="95%" class="order-dialog" top="25px"
             @close="router.replace({name:'home'}),orderFlag=false">
    <template #header>
      <h3 class="success-title">兑换成功</h3>
      <div>{{ order?.couponItems?.name }}（{{ order?.couponItems?.title }}）</div>
      <div style="font-size: .85rem">有效期：激活后{{ order?.couponItems?.term }}天内有效(须在60天内激活)</div>
    </template>
    <div class="order-info">
      <div class="tips">激活提示：{{ order?.detail?.tips }}</div>
      <div class="code-lst">
        <div class="code-item" v-for="(val,inx) in order?.hasCoupon" :key="inx"
             :class="order?.hasCoupon.length > 1?'code-flex':'code-one'">
          <div class="code-item-box">{{ val.code }}</div>
          <div class="code-copy" @click="copyText(val.code),router.replace({name:'home'}),orderFlag=false">
            点击复制激活码
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="less">
.coupon-list {
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  margin: 20px 15px 15px;
  box-shadow: var(--el-box-shadow);
  position: relative;

  .product-header {
    position: absolute;
    top: -18px;
    z-index: 999;
    left: 0;
    right: 0;
    height: 45px;
    text-align: center;
    line-height: 45px;
    font-size: 1.33rem;
    color: #ffffff;
    font-weight: 600;
    background-image: url("@/assets/images/sqwl/coupon-banner.png");
    background-position: center 6px;
    background-repeat: no-repeat;
    background-size: 220px auto;

    .bottom-header {
      width: 220px;
      margin: 6px auto;
    }
  }

  .coupon-lst {
    margin-top: 25px;

    .coupon-items {
      background-image: url("@/assets/images/sqwl/coupon.png");
      margin-bottom: 15px;
      border-radius: 12px;
      padding: 10px;
      //height: 80px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;

      .coupon-prices {
        flex-basis: 70px;
        font-size: .7rem;
        color: #ffffff;
        box-sizing: border-box;
        padding: 20px 10px;

        .face_value {
          font-size: 1.45rem;
        }
      }

      .coupon-contents {
        margin-left: 25px;
        flex-basis: calc(100% - 100px);
        width: calc(100% - 100px);
        line-height: 1.8;
        //padding-left: 20px;

        .coupon-values {
          display: flex;
          justify-content: space-between;
          font-size: .6rem;
          width: 100%;
          align-items: center;

          .coupon-discount-values {
            font-size: 1.15rem;
            color: #E31D1A;
          }
        }
      }
    }
  }
}

.recharge-step-items {
  padding: 10px;

  .recharge-step-items-tabs {
    background-repeat: no-repeat;
    height: 60px;
    background-size: 100%;
    display: flex;
    position: relative;
    z-index: 9;

    &.waiting_recharge {
      background-image: url("@/assets/images/sqwl/waiting.png");
    }

    &.real_recharge {
      background-image: url("@/assets/images/sqwl/recharge.png");
    }

    .step-item-1 {
      flex-basis: 50%;
      height: 60px;
      width: 50%;
    }


  }

  .recharge-step-items-content {
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    margin-top: -20px;
    border-radius: 0 0 12px 12px;

    .recharge-content {
      //padding-left: 15px;
      line-height: 1.8;
      text-align: justify;

      .recharge-content-its {
        padding: 15px;

        h3 {
          margin-bottom: 15px;
        }

        & + .recharge-content-its {
          border-top: 3px dashed #e5e5e5;
        }

        .recharge-content-val {
          font-size: .85rem;
        }
      }
    }
  }

  .real-content-box {
    display: flex;
    justify-content: space-between;
    line-height: 1.8;
    align-items: center;
    box-sizing: border-box;
    padding: 15px;
    background: var(--theme-color);
    border: 1px solid var(--theme-copyright-color);
    border-radius: 10px;

    & + .real-content-box {
      margin-top: 10px;
    }
  }
}

.order-info {
  box-sizing: border-box;
  padding: 20px;
  line-height: 1.75;

  .tips {
    color: #EE4F4F;
  }

  .code-item {
    margin-top: 15px;
    font-size: 1.25rem;

    .code-item-box {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .code-copy {
      color: #E31D1A;
    }

    &.code-one {
      text-align: center;
      display: block;
    }

    &.code-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code-item-box {
        flex-basis: 55%;
      }

      .code-copy {
        font-size: .85rem;
      }
    }
  }
}

</style>
